import { GetterTree } from 'vuex'
import { StoreInterface } from 'src/store'
import { UserStateInterface } from 'src/store/user/state'
import { DefaultRole, User } from 'able-lib'

const getters: GetterTree<UserStateInterface, StoreInterface> = {
  getUser: (state: UserStateInterface): User => state.user,

  getUserRole: ({ user }): DefaultRole => {
    if (!user) return null

    return user?.userRoles[0]?.role?.name as DefaultRole
  },

  hasRole: ({ user }) => (roleName): boolean => {
    const foundRole = user.userRoles.find(userRole => userRole.role.name === roleName)
    return !!foundRole || false
  },

  getUsers: (state: UserStateInterface): Array<User> => state.users
}

export default getters
